export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_SSO_INIT = `${process.env.REACT_APP_SSO_INIT}?return_path=REDIRECT_PATH`;
